import TopStrip from '@/pages/home/components/TopStrip';
import SiteHeader from '@/pages/home/components/SiteHeader';
import HeroSection from '@/pages/home/components/HeroSection';
import TopicWall from '@/pages/home/components/TopicWall';
import CollectionIndex from '@/pages/home/components/CollectionIndex';
import TimelineSection from '@/pages/home/components/TimelineSection';
import KeywordIndex from '@/pages/home/components/KeywordIndex';
import CtaBand from '@/pages/home/components/CtaBand';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <div className="sticky top-0 z-50">
        <TopStrip />
        <SiteHeader />
      </div>

      <main>
        <HeroSection />
        <TopicWall />
        <CollectionIndex />
        <TimelineSection />
        <KeywordIndex />
        <CtaBand />
      </main>

      <SiteFooter />
    </div>
  );
}